'use client';
import { Alert, Box, Typography } from '@mui/material';
import Exercise from '@/components/exercise/exercise';
import BuyCoursePrompt from '@/components/shared/buy-course-prompt';
import LoginPrompt from '@/components/shared/login-prompt';
import Unit from '@/components/unit/unit';
import { useAuth, useCourses } from '@/providers';
import { isExercise, isUnit } from '@/types';

export default function CourseLearnContent() {
  const { isLoggedIn } = useAuth();
  const { hasChapterAccess, selectedChapter, selectedCourse } = useCourses();

  if (
    !selectedCourse ||
    !selectedChapter ||
    (!isExercise(selectedChapter) && !isUnit(selectedChapter))
  ) {
    return (
      <Alert severity="error" sx={{ m: 2 }}>
        Inhalt konnte nicht gefunden werden.
      </Alert>
    );
  }

  const { wpProductId } = selectedCourse;
  const { access, title } = selectedChapter;

  return (
    <Box
      sx={{
        width: '100%',
        maxWidth: 640,
        m: '0 auto 64px',
        px: { xs: 2, md: 0 },
        '& img': {
          maxWidth: '100%',
          height: 'auto',
        },
      }}>
      <Typography
        typography="h1"
        gutterBottom
        sx={{ mt: 3, mb: 4, userSelect: 'none', hyphens: 'auto' }}>
        {title}
      </Typography>
      {!isLoggedIn && access === 'login' && (
        <LoginPrompt>
          Registriere Dich, um dieses Kapitel <strong>kostenlos</strong> nutzen zu können.
        </LoginPrompt>
      )}
      {!hasChapterAccess && access === 'membership' && (
        <BuyCoursePrompt wpProductId={wpProductId}>
          Kaufe den Kurs, um dieses Kapitel nutzen zu können.
        </BuyCoursePrompt>
      )}
      {hasChapterAccess && isExercise(selectedChapter) && <Exercise exercise={selectedChapter} />}
      {hasChapterAccess && isUnit(selectedChapter) && <Unit unit={selectedChapter} />}
    </Box>
  );
}
